import { AutoComplete } from 'primereact/autocomplete'
import { Button } from 'primereact/button';
import { classNames } from 'primereact/utils';
import React, { useEffect, useState } from 'react'

import './AutoCompleteDropdown.scss'

const AutoCompleteDropdown = ({
    name,
    value,
    field,
    items,
    itemsFilter,
    label = null,
    disabled,
    placeholder = null,
    tabIndex = null,
    itemTemplate = null,
    handleInputChange = () => { },
    onValueChange = () => { },
    setValue = () => { },
    className = null,
    labelStyle = {},
    hidden = false,
    stopEditing = () => { },
    enable = true,
    styles = {},
    values = [],
    IdValue = ''
}) => {

    const [filterFuncion, setFilterFuncion] = useState([]);
    const [filteredItems, setFilteredItems] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState(-1);

    const completeMethod = (event) => {
        let query = event.query;
        let _filteredItems = [];
        _filteredItems = filterFuncion.filter(item => item[field]?.toLowerCase().indexOf(query?.toLowerCase()) >= 0)
        setFilteredItems(_filteredItems);
        setSelectedIndex(-1); // Reset selected index when filtering
    }

    const selectItem = (item, e) => {
        handleInputChange({ target: { name: name, value: item } });
        onValueChange({ value: item });
        setValue(item);
    }

    const onBlur = (e) => {
        // console.log(typeof value, value);
        if (typeof value === 'string') {
            if (value === '') {
                selectItem(null);
            } else {
                // console.log({filteredItems});
                let selectedItem = filteredItems.find(item => item[field] === value);
                // console.log(selectedItem);
                if (selectedItem && filteredItems.length > 0) {
                    selectedItem = filteredItems[0];
                    selectItem(selectedItem);
                }else{
                    selectItem(null);
                    // selectedItem = null;
                }
            }
        }
        // else if (typeof value === 'object') {
        //     selectItem(null);
        // }
    }

    const stopPropagation = (e) => {
        if (e.key === 'Enter' || e.key === 'Tab') {
            e.stopPropagation();
            if (selectedIndex >= 0 && selectedIndex < filteredItems.length) {
                const selectedItem = filteredItems[selectedIndex];
                selectItem(selectedItem);
            } else {
                if (filteredItems.length > 0) {
                    if (filteredItems.length > 0) {
                        if (value === '' || value === null) {
                            selectItem(null)
                        } else {
                            if (typeof value === 'string') {
                                const selectedItem = filteredItems[0];
                                selectItem(selectedItem)
                            }
                            if (typeof value === 'object') {
                                stopEditing();
                            }
                        }
                    }
                }
                setTimeout(() => {
                    stopEditing();
                }, 100);
            }
            if (e.key === 'Escape') {
                stopEditing();
            }
        }
    }

    const handleKeyDown = (e) => {
        if (e.key === 'ArrowDown') {
            setSelectedIndex((prevIndex) => Math.min(prevIndex + 1, filteredItems.length - 1));
        } else if (e.key === 'ArrowUp') {
            setSelectedIndex((prevIndex) => Math.max(prevIndex - 1, 0));
        } else if (e.key === 'Enter') {
            stopPropagation(e);
        }
    }


    useEffect(() => {
        if (itemsFilter) {
            const t = itemsFilter();
            setFilterFuncion(t);
        } else {
            setFilterFuncion(items);
        }
    }, [items, itemsFilter]);


    useEffect(() => {

        if(values[IdValue]){
            const selectdItem = items.find(item => item[IdValue] === values[IdValue]);
            // console.log({selectdItem});
            setTimeout(() => {
                selectItem(selectdItem);
            }, 300);
        }
    }, [values[IdValue]]);

    return (
        <div className={classNames('AutoCompleteContainer animate__animated animate__fadeIn' + name, { hidden: hidden })} style={{ zIndex: 3000 }}>
            <span className='encabezado__contenido p-float-label AutoCompleteDropdown d-flex'>
                {value && !disabled && enable && <Button
                    className='clearButton'
                    icon="pi pi-times"
                    text
                    severity='danger'
                    onClick={() => {
                        handleInputChange({ target: { name: name, value: null } });
                        onValueChange({ value: null });
                        setValue(null);
                    }}
                />}
                <AutoComplete
                    id={name}
                    name={name}
                    value={value}
                    setValue={setValue}
                    tabIndex={tabIndex}
                    suggestions={filteredItems}
                    completeMethod={completeMethod}
                    field={field}
                    itemTemplate={itemTemplate ?? (e => { return e[field] })}
                    selectedItemTemplate={e => { return e[field] }}
                    tooltip={value?.field ?? null}
                    tooltipOptions={{ position: 'top' }}
                    onChange={(e) => {
                        handleInputChange(e);
                        onValueChange(e);
                        setValue(e.value);
                    }}
                    aria-label={field}
                    placeholder={placeholder}
                    className={classNames('autocompleteInput col-12', className)}
                    onSelect={e => {
                        selectItem(e.value);
                        setTimeout(() => {
                            stopEditing();
                        }, 100);
                    }}
                    onBlur={e => onBlur(e)}
                    dropdown
                    onKeyDown={handleKeyDown}
                    onKeyPress={stopPropagation}
                    onKeyDownCapture={stopPropagation}
                    onKeyUpCapture={stopPropagation}
                    dropdownMode="blank"
                    disabled={!enable}
                    removeIcon
                    style={styles}
                />
                <label style={labelStyle}>{label ?? name}</label>
            </span>
        </div>
    )
}

export default AutoCompleteDropdown